export function positioningTooltip (chart, tooltip, tooltipEl) {
  const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas
  const chartRect = chart.canvas.getBoundingClientRect()
  let left = positionX + tooltip.caretX

  if (chartRect.left + tooltip.caretX + tooltipEl.offsetWidth > window.innerWidth) {
    left = positionX + tooltip.caretX - tooltipEl.offsetWidth
  }

  tooltipEl.style.opacity = 1
  tooltipEl.style.left = left + 'px'
  tooltipEl.style.top = positionY + tooltip.caretY + 'px'
  tooltipEl.style.font = tooltip.options.bodyFont.string
}

// Цвет серии из палитры приходит в hex, для полупрозрачной заливки chart.js нужен rgba.
export function hexToRgba (hex, alpha) {
  const normalized = String(hex).replace('#', '')
  const full = normalized.length === 3
    ? normalized.split('').map(char => char + char).join('')
    : normalized

  const r = parseInt(full.slice(0, 2), 16)
  const g = parseInt(full.slice(2, 4), 16)
  const b = parseInt(full.slice(4, 6), 16)

  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}
